import { CardContent, Grid, Typography} from "@mui/material"
import MyTable, { TableRow } from "../../../components/MyTable";

import { TableHeadRows } from "../../../components/MyTable/TableHead";
import DownloadButtonDocument from "../../my-potal/documents/downloadButtonDocument";
import { CONTRACT_DOCUMENT_SIGNATURE_REQUEST } from "../../../constants/signalRequestConsts";
import { formatDateToTimestamp } from "../../../utils/date";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { InMyChargeEmployeeContractsRequestId } from "../../../store/slices/userRequests";


interface TableEmployeesContractsProps {
    requestId: InMyChargeEmployeeContractsRequestId,
    description: string;
    setDescription: (desc: string) => void;
    pageSize: number;
    setPageSize: (page: number) => void;
    page: number;
    setPage: (page: number) => void;
}

const TableEmployeesContracts = ({
    requestId, 
    description,
    setDescription,
    pageSize,
    setPageSize,
    page,
    setPage,
}: TableEmployeesContractsProps) => {

    const {contracts, isLoading, totalItems} = useSelector((state: RootState) => state.userRequests)[requestId];
    
    const tableHeadRows = [
        
        {
            label: "Colaborador",
            rowKeyName: "Descripcion",
            allowOrderAction: true,
        },{
            label: "Empresa",
            rowKeyName: "Empresa",
            allowOrderAction: true,
        },{
            label: "Número",
            rowKeyName: "NumeroContrato",
            allowOrderAction: true,
        },{
            label: "Tipo contrato",
            rowKeyName: "TipoContrato",
            allowOrderAction: true,
        },{
            label: "Fecha inicio",
            rowKeyName: "FechaInicio",
            allowOrderAction: true,
        },{
            label: "Fecha fin",
            rowKeyName: "FechaFin",
            allowOrderAction: true,
        },{
            label: "Días finalizar",
            rowKeyName: "DiasVencimiento",
            allowOrderAction: true,
        },{
            label: "Oficina",
            rowKeyName: "Area",
            allowOrderAction: true,
        },{
            label: "Estado",
            rowKeyName: "EstadoAceptacion",
            allowOrderAction: true,
        },{
            label: "Fec. envío",
            rowKeyName: "FechaEnviadoPortal",
            allowOrderAction: true,
        },{
            label: "Fec. firma",
            rowKeyName: "FirmadoFecha",
            allowOrderAction: true,
        },{
            label: "Observación",
            rowKeyName: "FirmadoRespuesta",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                return <Grid
                    container 
                    justifyContent="space-between" 
                    direction="row"
                    style={{minWidth: row.FirmadoRespuesta ? "11rem" : "7rem"}}
                >
                    <Grid 
                        item 
                        style={{
                            width: row.FirmadoRespuesta ? "9rem" : "3rem", 
                            // whiteSpace: "nowrap", 
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            lineClamp: "2",


                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",


                        }}>
                        {row.FirmadoRespuesta}
                    </Grid>
                </Grid>
            }
        },{
            label: "",
            rowKeyName: "viewFile",
            customValue: (headRow: TableHeadRows, row: TableRow<string, any>) => {
                return (
                <DownloadButtonDocument
                    signButton={false}
                    FirmaTop={row.FirmaTop}
                    FirmaLeft={row.FirmaLeft}
                    FirmaPagePosition={row.FirmaPagina}
                    NroFs={row.NroFS}
                    FirmadoFecha={row.FirmadoFecha} 
                    IdDocument={row.NroIdentificadorContrato}
                    requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                    signDisabled={true}
                    
                />
            )},
        }
    ]

    return  (
        <>
        <MyTable
            key="tab-0"
            pageNumber={page}
            itemsPerPage={pageSize}
            totalItems={totalItems}
            totalPages={totalItems / pageSize}
            searchInputString={description}
            onChangePageNumber={setPage}
            onChangeItemsPerPage={setPageSize}
            onChangeSearchInputString={setDescription}
            hiddenSearchInput={false}
            tableHeadRows={tableHeadRows}
            // hiddenFilterOptions={hiddenFilterOptions}
            tableRows={contracts}
            loading={isLoading}
            cardComponent={
                {
                    cardContent: (row) => {
                    return (
                        <CardContent style={{padding: "0 1rem 1rem 1rem"}}>
                            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                <Grid item xs>
                                    <Typography variant="subtitle2" color="text.primary" marginBottom=".2rem">
                                        {row.Descripcion}
                                    </Typography>
                                </Grid>
                                <Grid item maxWidth="2rem">
                                    <DownloadButtonDocument
                                        signButton={false}
                                        FirmaTop={row.FirmaTop}
                                        FirmaLeft={row.FirmaLeft}
                                        FirmaPagePosition={row.FirmaPagina}
                                        NroFs={row.NroFS}
                                        FirmadoFecha={row.FirmadoFecha} 
                                        IdDocument={row.NroIdentificadorContrato}
                                        requestId={CONTRACT_DOCUMENT_SIGNATURE_REQUEST}
                                        signDisabled={true}
                                        
                                    />
                                </Grid>
                            </Grid>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Empresa: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Empresa}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Tipo: {" "}
                                <Typography variant="body2" component="span">
                                    {row.TipoContrato || ""}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Oficina: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Area}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Número: {" "}
                                <Typography variant="body2" component="span">
                                    {row.NumeroContrato || ""}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Estado: {" "}
                                <Typography variant="body2" component="span">
                                    {row.EstadoAceptacion}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Inicio: {" "}
                                <Typography variant="body2" component="span">
                                    {(formatDateToTimestamp(row.FechaInicio) as any)?.split(" ")[0]}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Fin: {" "}
                                <Typography variant="body2" component="span">
                                    {(formatDateToTimestamp(row.FechaFin) as any)?.split(" ")[0]}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Días finalizar: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.DiasVencimiento) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Envío: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FechaEnviadoPortal) as any}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha Firma: {" "}
                                <Typography variant="body2" component="span">
                                    {formatDateToTimestamp(row.FirmadoFecha) as any}
                                </Typography>
                            </Typography>
                        </CardContent>
                    );
                },
                numberOfCards: 1,
                changeViewOptionHidden: true,
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
            hiddenBottomPaginator={true}
        />
        </>
    )
}

export default TableEmployeesContracts